<template>
  <div class="grid grid--wide">
    <div class="xs-12">
      <div class="myhome-home__agent">
        <h3 class="myhome-home__agent-title">
          Ciao {{ user.firstname }} {{ user.lastname }}, visualizza come docente i siti libro di tutti i prodotti
          deascuola:
        </h3>
        <form ref="form" class="dea-autosuggest-search-form" autocomplete="off" @submit.stop.prevent="searchForm">
          <Autosuggest
            :autosuggest="$root.config.autosuggest"
            :show-header-top="false"
            :config="$root.config"
            component="custom"
            class="dea-autosuggest--in-page"
            :use-overlay="false"
            :filter-by-grade="false"
          ></Autosuggest>
        </form>
        <div v-if="availableDegrees.length" id="new-booklist" class="myhome-home__agent-books">
          <div class="grid grid--wide">
            <div class="xs-12 m-5">
              <h2 class="myhome-home__agent-books-title dea-heading--medium__xl">Demo digitali novità</h2>
            </div>
            <div class="xs-12 m-7 myhome-home__agent-books-actions">
              <div class="myhome-home__agent-books-goto">
                <Links class="dea-links--target-color-blue-docenti dea-links--large">vai a</Links>
              </div>
              <div v-for="(item, key) in availableDegrees" :key="key" class="myhome-home__agent-books-scroll-buttons">
                <Buttons class="dea-button--outline dea-button--outline dea-button--large" @click="scrollToGrade(item)"
                  >Demo {{ item.name }}</Buttons
                >
              </div>
            </div>
          </div>
          <div v-for="(item, key) in availableDegrees" :key="key" class="myhome-home__newbooks-list">
            <h2 :id="`degrees-${item.id}`" class="dea-heading--regular__l">{{ item.name }}</h2>
            <BooksList
              :async-conf="$root.asyncConf"
              :items="item.books"
              :list-columns="12"
              :link-minisite="true"
              columns-class="bookslist__column bookslist__column--agents"
              card-type="image-only"
              :agent="user.agent"
              :badge-new="false"
              link-target="_blank"
              :deascuola-search="false"
              :grid-wide="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/components/mixins/utils";
import Links from "@/components/elements/Links";
import Buttons from "@/components/elements/Buttons";
import BooksList from "@/components/patterns/BooksList";
import Autosuggest from "@/components/patterns/Autosuggest";

export default {
  name: "HomeAgentBooks",
  // eslint-disable-next-line vue/no-unused-components
  components: { BooksList, Buttons, Links, Autosuggest },
  props: {
    user: {
      type: Object,
      required: true,
    },
    books: {
      type: Array,
      required: true,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closeAutosuggest: false,
      availableDegrees: this.books.filter(deg => deg.books.length),
      autosuggestPortalClass: "",
    };
  },
  computed: {
    degreesList() {
      return this.$root.asyncConf.degrees_json || [];
    },
  },
  watch: {
    books() {
      this.availableDegrees = this.books.filter(deg => deg.books.length);
    },
  },

  mounted() {
    if (this.query) {
      this.filters.q = this.query;
      this.runSearch();
    }
  },
  methods: {
    autosuggest(item) {
      document.location = utils.createMinisiteUrl(item.time_id, this.$root.config);
    },
    searchForm(event) {
      const query = event.target[0].value;
      this.triggerSearch("q", null, query);
      this.closeAutosuggest = true;
      return false;
    },
    scrollToGrade(item) {
      try {
        window.scrollTo(0, this.$el.querySelector(`#degrees-${item.id}`).offsetTop);
      } catch (error) {
        window.scrollTop = this.$el.querySelector(`#degrees-${item.id}`).offsetTop;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-home__agent {
  &-title {
    margin: $space-x-large 0 $space-large;
    text-align: center;
  }

  .dea-autosuggest-search-form {
    position: relative;

    .autosuggest-container {
      &-ricerca {
        z-index: 0;
      }
    }

    .dea-autosuggest__result-wrapper {
      @include media("<m") {
        width: 100%;
      }

      margin-bottom: $space-large;
      margin-left: 0;
      position: relative;
      top: $space-xx-small;
      width: 100%;
    }
  }
}

.myhome-home__agent-books {
  margin-top: $space-intermediate;

  &-title {
    margin: 0;
  }

  &-actions {
    display: flex;
    justify-content: flex-end;
  }

  &-goto,
  &-scroll-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 $space-x-small;
  }
}
</style>
